import { env } from '@/env';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const noopAppInsights = {
  trackException: () => undefined,
  trackPageView: () => undefined,
  trackEvent: () => undefined,
};

const hasInstrumentationKey = Boolean(env.appInsights && env.appInsights.trim());

const appInsights = hasInstrumentationKey
  ? new ApplicationInsights({
      config: {
        instrumentationKey: env.appInsights, // A instrumentation key
        autoTrackPageVisitTime: true, // Flag para ativar rastreio automático de tempo por página
        enableAutoRouteTracking: true, // Flag para ativar o rastreio automático de rotas
      },
    })
  : noopAppInsights;

if (hasInstrumentationKey) {
  const configuredAppInsights = appInsights as ApplicationInsights;
  configuredAppInsights.loadAppInsights();
  configuredAppInsights.trackPageView();
}

export function useAppInsights() {
  return appInsights;
}
